import React, { useState } from 'react'
import styled from 'styled-components'
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { colors } from '../../Assets/styles/colors';
import { useTolgee } from '@tolgee/react';

const TimePicker = ({ id, date, setDate, minTime, maxTime, minDateTime, readOnly }) => {

    const [isOpen, setIsOpen] = useState(false);
    const tolgee = useTolgee();
    const currentLocale = tolgee.getLanguage();
    const normalizeDate = (val) => {
        if (val instanceof Date && !isNaN(val)) return val;
        if (!val) return null;
        const parsed = new Date(val);
        return isNaN(parsed) ? null : parsed;
    };

    const selectedDate = normalizeDate(date);
    const minDateTimeValue = normalizeDate(minDateTime);
    
    const dayStart = new Date();
    dayStart.setHours(0, 0, 0, 0); // Midnight

    const dayEnd = new Date();
    dayEnd.setHours(23, 55, 0, 0); // 11:55 PM

    return (
        <Wrapper $readOnly={readOnly}>
            <DatePicker
                id={id}
                readOnly={readOnly}
                selected={selectedDate}
                open={readOnly ? false : isOpen}
                onInputClick={() => !readOnly && setIsOpen(true)}
                onClickOutside={() => setIsOpen(false)}
                onChange={readOnly ? undefined : (nextDate) => {
                    const safeDate = normalizeDate(nextDate);
                    setIsOpen(false);
                    if (!safeDate) return;
                    if (minDateTimeValue && safeDate.getTime() < minDateTimeValue.getTime()) {
                        return;
                    }
                    setDate(safeDate);
                }}
                showTimeSelect
                showTimeSelectOnly
                timeIntervals={5}
                timeCaption="Time"
                dateFormat="HH:mm"
                timeFormat="HH:mm"
                minTime={normalizeDate(minTime) || dayStart}
                maxTime={normalizeDate(maxTime) || dayEnd}
                showTimeCaption={false}
                locale={currentLocale.split('-')[0]}
            />
            {readOnly && <InteractionBlocker aria-hidden="true" />}

        </Wrapper>
    )
}

export default TimePicker
const Wrapper = styled.div`
display:flex;
position:relative;


.react-datepicker__time{
background:none !important;
}
.react-datepicker__input-container{
display:flex;
padding:0 10px;
width:80px;
    background:${({ theme }) => theme.menu.enterPhoneNumberBackground};
border-radius:5px;
overflow:hidden;
justify-content:center;

input{
outline:none;
background:none;
border:none;
padding:5px;
border-radius:5px;
width:55px;
 font-size: 16px;
    font-weight: 400;
    line-height: 22px;
     color:${({ theme }) => theme.menu.primaryTextColor};
     cursor:${({ $readOnly }) => $readOnly ? "default" : "text"};
     pointer-events:${({ $readOnly }) => $readOnly ? "none" : "auto"};
}

}

.react-datepicker--time-only{
background:transparent;
overflow:hidden;
border:1px solid  ${({ theme }) => theme.sidebar.borderColor};
}

.react-datepicker__time-list-item{
 color:${({ theme }) => theme.menu.primaryTextColor};
    background:${({ theme }) => theme.menu.enterPhoneNumberBackground};
}

.react-datepicker__time-list-item:hover{
 background:${({ $readOnly, theme }) => $readOnly ? theme.menu.enterPhoneNumberBackground : theme.menu.background}!important;
  color:${({ theme }) => theme.menu.primaryTextColor}!important;
  cursor:${({ $readOnly }) => $readOnly ? "default" : "pointer"};
}

.react-datepicker__time-list-item--selected{
 background: ${({ theme }) => theme.menu.selectedTextColor}!important;
}
.react-datepicker__triangle{
stroke: ${({ theme }) => theme.menu.selectedTextColor}!important;
fill: ${({ theme }) => theme.menu.selectedTextColor} !important;
color: ${({ theme }) => theme.menu.selectedTextColor}!important;
}
.react-datepicker__time-list-item--disabled{
background:${({ theme }) => theme.menu.background};
color:${({ theme }) => theme.menu.infoText}!important;
}
`

const InteractionBlocker = styled.div`
position:absolute;
inset:0;
cursor:not-allowed;
`;
